import { render, staticRenderFns } from "./GoodTableI18n.vue?vue&type=template&id=201bc078&"
import script from "./GoodTableI18n.vue?vue&type=script&lang=js&"
export * from "./GoodTableI18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports